module.exports = __webpack_public_path__ + "static/media/target-icon-active.87c5a042.svg";